export { default } from "./HomePageNewsCta";
